'use strict';

module.exports = footnoteReference;

var u = require('unist-builder');

/* Transform a reference to a footnote. */
function footnoteReference(h, node) {
  var identifier = node.identifier;

  return h(node.position, 'sup', {id: 'fnref-' + identifier}, [
    h(node, 'a', {
      href: '#fn-' + identifier,
      className: ['footnote-ref']
    }, [u('text', identifier)])
  ]);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/footnote-reference.js
// module id = 99
// module chunks = 96961042003272 139266963665775